import { graphql } from "~/gql";

export const DELETE_TECHNOLOGY_UNIT = graphql(/* GraphQL */ `
  mutation DeleteTechnologyUnit($id: Int!) {
    deleteTechnologyUnit(id: $id) {
      id
    }
  }
`);
